import React from 'react';
import { IconProps } from '.';

type BackIconProps = {
  color?: string;
} & IconProps;

export const Back: React.FC<BackIconProps> = ({
  height = 21,
  width = 14,
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      fill="none"
      viewBox="0 0 14 21"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M12.5 1L2 10.5 12.5 20"
      ></path>
    </svg>
  );
};
